/**
 * I-41 · Desde el 21/10 cada fila de progreso de LMX muestra un texto en
 * castellano («Agregando un nodo») y el nombre real de la herramienta viaja
 * aparte en `tool`. El canvas y el timeline se sincronizan (y animan) según
 * ESE nombre. Sin esto no se enteraban de los cambios de LMX: sin animación
 * de armado, sin destello de clips y con el timeline sin refrescar.
 */
export const toolOf = (row) => {
  if (row?.tool) return String(row.tool);
  // Respaldo para filas viejas (rehidratadas) que sólo traen el label.
  return String(row?.label || '').split(/[\s·]/)[0];
};

export default toolOf;
